import { connect } from 'react-redux';

import { selectLatestNews } from 'pages/News/NewsDetails/store/selectors';

import { RootState } from '../../store';

const mapStateToProps = (state: RootState) => ({
  list: selectLatestNews(state),
});

export const connector = connect(mapStateToProps);
